import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class Service
{
    Key: string;
    Cli: string;

    constructor(private http: HttpClient)
    {
        this.Key = environment.k;
        this.Cli = environment.c;
    }

    get(url: string): Observable<any>
    {
        const authToken = localStorage.getItem('accessToken');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        });
        const cacheBuster = `_t=${new Date().getTime()}`;
        const finalUrl = url.includes('?') ? `${url}&${cacheBuster}` : `${url}?${cacheBuster}`;
        return this.http.get(finalUrl, { headers: headers });
    }

    post(url: string, body: any): Observable<any>
    {
        const authToken = localStorage.getItem('accessToken');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        });
        return this.http.post(url, body, { headers: headers });
    }

    postFormData(url: string, body: any): Observable<any>
    {
        const authToken = localStorage.getItem('accessToken');
        const headers = new HttpHeaders({
            // 'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
            'Authorization': `Bearer ${authToken}`
        });
        return this.http.post(url, body, { headers: headers });
    }

    put(url: string, body: any): Observable<any>
    {
        const authToken = localStorage.getItem('accessToken');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        });
        return this.http.put(url, body, { headers: headers });
    }

    delete(url: string): Observable<any>
    {
        const authToken = localStorage.getItem('accessToken');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        });
        return this.http.delete(url, { headers: headers });
    }


    getKey(url: string): Observable<any>
    {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-App-Key': this.Key,
            'X-App-Client': this.Cli,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        });
        const cacheBuster = `_t=${new Date().getTime()}`;
        const finalUrl = url.includes('?') ? `${url}&${cacheBuster}` : `${url}?${cacheBuster}`;
        return this.http.get(finalUrl, { headers: headers });
    }

    postVisitorLog(url: any, version: string = '1'): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-App-Key': this.Key,
            'X-App-Client': this.Cli
        });
        const body = {};
        return this.http.post(url, body, { headers });
    }

}
